import { css } from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';

const CSSVariables = css`
    --sticky-header-height: 56px;

    ${forDesktop`
        --sticky-header-height: 0px;
    `}

    &:is(.webview) {
        --sticky-header-height: 0px;
    }
`;

export default CSSVariables;
